@if (!hideControl) {
  <div>
    @if (showFieldAsEdit && !readOnlyUser) {
      <div
        class="my-4">
        <topo-color-item-select
          [selectedUId]="selectedStepUId"
          [label]="selectedStatusName"
          [colorCode]="selectedStatusColorCode"
          itemLabel="statusName"
          itemColorCode="statusHtmlColorCode"
          [items]="workflowStepListItems"
          [isXLarge]="true"
          (itemSelected)="stepSelected($event)"
        isActive="false"></topo-color-item-select>
      </div>
    } @else {
      <div
        class="my-4"
        style="width: calc(100% - 2rem)"
        fxLayout="row"
        fxLayoutAlign="start center">
        <div
          class="workflow-color"
          [ngStyle]="{ 'background-color': selectedStatusColorCode }">
          &nbsp;
        </div>
        <div class="workflow-status">{{ selectedStatusName }}</div>
      </div>
    }
  </div>
}
